import { render, staticRenderFns } from "./ScriveAddSigningPartyField.vue?vue&type=template&id=e5882bf4&"
import script from "./ScriveAddSigningPartyField.vue?vue&type=script&lang=ts&"
export * from "./ScriveAddSigningPartyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports